import axios from '@/plugins/axios'

export default {
  namespaced: true,
  state: () => ({
    theme: {}
  }),
  getters: {
    theme(state) {
      return state.theme
    }
  },
  mutations: {
    setTheme(state, value) {
      state.theme = value
    }
  },
  actions: {
    async getTheme({commit}, company) {
      const response = await axios.post('login/auth/theme', { company })
      commit('setTheme', response.data.data)
      return response.data.data
    }
  }
}